import { render, staticRenderFns } from "./idassLogin.vue?vue&type=template&id=0b23200e&"
import script from "./idassLogin.vue?vue&type=script&lang=ts&"
export * from "./idassLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports